@if (enableRangeLayout) {
<div class="cf-wrap cf-wrap--btns">

    <div class="cf-row" [scrollable]="true" [scrollableXContainer]="scrollableContainerElement"
        [scrollableXElements]="scrollableElements" [scrollableXTransformTargets]="scrollableTransformTargets"
        [scrollableXElementsGap]="5" [scrollableXElementsBorderAdjustmentGap]="10">

        <div class="cf-row-inner" #scrollableContainer #scrollableTransformTarget>

            @if (enableAny) {
            <div class="cf-btn-box" #scrollableElement>

                <rpc-button class="cf-btn" [text]="'CHECKBOX_FILTER.TITLES.ANY'"
                    [color]="isAnySelected ? 'accent' : 'default'" [appearanceType]="isAnySelected ? 'flat' : 'stroke'"
                    (clicked)="toogleAny()">
                </rpc-button>

            </div>
            }

            @for (value of availableValues; track $index) {
            <div class="cf-btn-box" #scrollableElement>

                <rpc-button class="cf-btn"
                    [text]="((value.valueLocalizationKey | translate) + (isExactMatchSelected ? '' : notExactMatchAdditionalText))"
                    [color]="isAnySelected || currentSelectedValues.includes(value.value) ? 'accent' : 'default'"
                    [appearanceType]="isAnySelected || currentSelectedValues.includes(value.value) ? 'flat' : 'stroke'"
                    [disabled]="disabledValues?.includes(value.value)" (clicked)="toogleValue($index)">
                </rpc-button>

            </div>
            }

        </div>

    </div>

    @if (enableExactMatch) {
    <div class="cf-toogler-wrap">

        <rpc-slide-toggle class="cf-toogler" [togglePosition]="'right'" [checked]="isExactMatchSelected"
            [firstText]="'CHECKBOX_FILTER.TITLES.EXACT_MATCH'" [disabled]="isAnySelected"
            (changed)="toggleExactMatch($event.checked)">
        </rpc-slide-toggle>

    </div>
    }

</div>
} @else {
<div class="cf-wrap cf-wrap--chips">

    @for (item of availableValues; track $index) {
    <div class="cf-btn-box" #scrollableElement>

        <rpc-button class="cf-btn" [text]="item.valueLocalizationKey"
            [color]="currentSelectedValues.includes(item.value) ? 'accent' : 'default'"
            [appearanceType]="currentSelectedValues.includes(item.value) ? 'flat' : 'stroke'"
            [disabled]="disabledValues?.includes(item.value)" (clicked)="toogleValue($index)">
        </rpc-button>

    </div>
    }
</div>
}